var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Chip, Menu, useToast } from '@pocketlaw/tetris';
import { FileSystemProjectStatus } from 'shared/domains/apollo/generated/types';
import { useUpdateProjectStatus } from './useUpdateProjectStatus';
import { getProjectStatusAppearance, getProjectStatusIcon, getProjectStatusLabels } from './utils';
export function ProjectStatusChip(props) {
    const { status, projectId, showLabel = false, size = 'small' } = props;
    const { addToast } = useToast();
    const [updateStatus] = useUpdateProjectStatus();
    const labels = getProjectStatusLabels();
    const icon = getProjectStatusIcon(status);
    const orderedStatuses = [
        FileSystemProjectStatus.Backlog,
        FileSystemProjectStatus.InProgress,
        FileSystemProjectStatus.OnHold,
        FileSystemProjectStatus.Completed,
        FileSystemProjectStatus.Cancelled,
    ];
    const chipProps = {
        size,
        icon,
        label: showLabel ? t({ message: 'Status', comment: 'Project status chip - Label' }) : undefined,
        secondary: labels[status],
        appearance: getProjectStatusAppearance(status),
    };
    const handleUpdateStatus = (projectStatus) => __awaiter(this, void 0, void 0, function* () {
        if (!projectId) {
            return;
        }
        try {
            yield updateStatus(projectId, projectStatus);
        }
        catch (_a) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Failed to update project status',
                    comment: 'Project status chip - Error toast title when updating project status',
                }),
                message: t({
                    message: 'Something went wrong when updating the project status, please try again',
                    comment: 'Project status chip - Error toast message when updating project status',
                }),
            });
        }
    });
    if (projectId) {
        return (<Menu.Root target={<Chip {...chipProps}/>}>
        {orderedStatuses.map((s) => (<Menu.Item key={s} onClick={() => handleUpdateStatus(s)}>
            {getProjectStatusIcon(s)}
            {labels[s]}
          </Menu.Item>))}
      </Menu.Root>);
    }
    return <Chip {...chipProps}/>;
}
